import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocDataOnce,
  useUser,
} from 'reactfire';
import { collection, doc, orderBy, query, where } from 'firebase/firestore';

import ChangeRequestsTable from '../chat/changeRequest/ChangeRequestsTable';
import { DashboardWrapper } from '../../styled/DashboardDrawer.styled';

import { ChangeRequest } from '../../types';

const Dashboard = () => {
  const firestore = useFirestore();

  const { data: user } = useUser();
  const { data: userMeta } = useFirestoreDocDataOnce(
    doc(firestore, 'users', user?.uid || ''),
  );
  const isAdmin = userMeta.role === 'admin';
  const showRequestsQuery = isAdmin || userMeta.role === 'auditor';

  const { userUid } = useParams();

  const changeRequestsCollection = collection(firestore, 'changeRequests');

  const changeRequestsQuery = useMemo(() => {
    return query(
      changeRequestsCollection,
      orderBy('createdAt', 'desc'),
      where('userId', '==', showRequestsQuery && userUid ? userUid : user?.uid),
    );
  }, [showRequestsQuery, user, changeRequestsCollection, userUid]);

  const { data: changeRequests } = useFirestoreCollectionData(
    changeRequestsQuery,
    {
      idField: 'id',
    },
  );

  return (
    <DashboardWrapper>
      <ChangeRequestsTable
        changeRequests={changeRequests as ChangeRequest[]}
        isAdmin={isAdmin}
      />
    </DashboardWrapper>
  );
};

export default Dashboard;
